module.exports = __webpack_public_path__ + "static/audio/narrations_fr.21a3358.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/music/music/narrations_fr.mp3
// module id = V2/W
// module chunks = 1